<template>
  <CommonTabs
    resource="profile"
    :tabs="tabs"
    :components="components"
    :default-router="defaultRouter"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../components/common/tabs/CommonTabs";
import EditEmail from "./../components/profile/EditEmail";
import EditPassword from "./../components/profile/EditPassword";
import EditProfile from "./../components/profile/EditProfile";
import { title } from "../components/mixins/title";
export default {
  name: "Profile",
  mixins: [title],
  components: {
    CommonTabs
  },
  data: () => ({
    defaultRouter: { name: "Dashboard" },
    components: {
      EditEmail,
      EditPassword,
      EditProfile
    },
    tabs: [
      {
        title: "general-settings",
        component: "EditProfile"
      },
      {
        title: "change-email",
        component: "EditEmail"
      },
      {
        title: "change-password",
        component: "EditPassword"
      }
    ]
  }),
  methods: {
    getArgumentForTitle() {
      return {
        chain: [this.$t("profile.profile")]
      };
    }
  }
};
</script>

<style scoped>
.back-arrow {
  transform: translateX(-16px);
}
</style>
